import { z } from "zod";

import { gradientPositions } from "@jti/ui/components/HeroV2/types/HeroV2Types";

export const HeroV2CtaTypeSchema = z.object({
  additionalBehavior: z.union([z.literal(null), z.enum(["onlyForLoggedIn", "onlyForNotLoggedIn", "always"])]),
  link: z.string().min(1, "Link is required"),
  label: z.string().min(1, "Label is required"),
  theme: z.enum(["light", "dark"]),
  layout: z.enum(["chevron", "full", "border"]),
  tracking: z.string().min(1, "Tracking is required"),
  target: z.enum(["_blank", ""]),
});

export const DiscountSchema = z.object({
  currentPrice: z.string(),
  originalPrice: z.string(),
  packInformation: z.string().optional(),
  priceDisclaimer: z.string().optional(),
});

const HeroBaseSchema = z.object({
  clipped: z.boolean(),
  content: z.object({
    title: z.string().optional(),
    titleLogged: z.string().optional(),
    tagLine: z.string().optional(),
    text: z.string().optional(),
    cta: z.array(HeroV2CtaTypeSchema).optional(),
    discounts: z.array(DiscountSchema).optional(),
    subheadline: z.string().optional(),
    subheadlineLogged: z.string().optional(),
    textLogged: z.string().optional(),
  }),
  displayScrollBar: z.boolean(),
  legalDisclaimer: z.string().optional(),
  logo: z.string().optional(),
  mobileVariant: z.enum(["transparentContentOnTop", "contentAtTheBottomWithBackground"]),
  removeVideoRoundedCorners: z.boolean().optional(),
  gradientPosition: z.enum(gradientPositions).optional(),
  gradientPositionTablet: z.enum(gradientPositions).optional(),
  gradientPositionMobile: z.enum(gradientPositions).optional(),
  theme: z.enum(["light", "dark", "inherit"]).optional(),
});
const ImageSchema = z.object({
  src: z.string(),
  alt: z.string(),
  title: z.string(),
});

const OptionalImageSchema = z.object({
  src: z.string().optional(),
  alt: z.string().optional(),
  title: z.string().optional(),
});

const HeroWithImageSchema = HeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("image"),
    desktopImage: ImageSchema,
    mediumImage: OptionalImageSchema.optional(),
    smallImage: ImageSchema,
  })
);

export const HeroWithVideoSchema = HeroBaseSchema.merge(
  z.object({
    backgroundType: z.literal("video"),
    videoFileReference: z.string().optional(),
    videoFileType: z.string().optional(),
    tabletVideoFileReference: z.string().optional(),
    tabletVideoFileType: z.string().optional(),
    mobileVideoFileReference: z.string().optional(),
    mobileVideoFileType: z.string().optional(),
  })
);

export const HeroDataSchema = z.discriminatedUnion("backgroundType", [HeroWithImageSchema, HeroWithVideoSchema]);
